import * as React from 'react';
import { styled } from '@linaria/react';

import { random, sampleOne } from '@/utils';

export const BALL_SIZE = 32;
export const BOUNCE_MAGNITUDE = 128;
export const BALL_CONTAINER_SIZE = BALL_SIZE + BOUNCE_MAGNITUDE;

export const BOUNCE_TIME = 1000;

export function useSimulateWork(isPlaying: boolean) {
  const [isSimulatingWork, setIsSimulatingWork] =
    React.useState(false);

  React.useEffect(() => {
    if (!isPlaying) {
      return;
    }

    let timeoutId: number | null = null;

    function simulateWork() {
      setIsSimulatingWork(true);

      timeoutId = window.setTimeout(() => {
        const start = performance.now();

        const duration = sampleOne([
          380, 420, 550, 570, 590, 600, 700, 810, 1234, 1678,
        ]);

        while (performance.now() - start < duration) {
          // Block the main thread for this duration
        }

        // Wait a random amount of time before starting more work
        setIsSimulatingWork(false);

        timeoutId = window.setTimeout(
          simulateWork,
          random(700, 3000)
        );
      }, 24);
    }

    timeoutId = window.setTimeout(simulateWork, 500);

    return () => {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [isPlaying]);

  return {
    isSimulatingWork,
    setIsSimulatingWork,
  };
}

export const Ball = styled.div`
  width: ${BALL_SIZE}px;
  height: ${BALL_SIZE}px;
  border-radius: 50%;
  background: var(--wham-primary-500);
`;
